<route>{ "meta": { "moduleCode": "VEHICLE_WORK_ORDER" } }</route>
<template>
    <CardList :list="list"/>
</template>

<script>
import CardList from "@/components/card-list/CardList.vue";

export default {
    name: "vehicle-work-order",
    components: {CardList},
    data() {
        return {
            list: [
                {
                    slug: '/module/vehicle-work-order/type/',
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.type.title"),
                    description: this.$t("pages.module.VEHICLE_WORK_ORDER.type.description"),
                    svgIcon: '/media/icons/duotune/general/gen022.svg',
                },
                {
                    slug: '/module/vehicle-work-order/list',
                    name: this.$t("menu.vehicleWorkOrderList"),
                    description: this.$t("pages.module.VEHICLE_WORK_ORDER.description"),
                    svgIcon: '/media/icons/duotune/general/gen005.svg',
                },
                {
                    slug: '/module/vehicle-work-order/save',
                    name: this.$t("menu.vehicleWorkOrderAdd"),
                    description: this.$t("pages.module.VEHICLE_WORK_ORDER.save.description"),
                    svgIcon: '/media/icons/duotune/abstract/abs011.svg',
                },
                {
                    slug: '/module/vehicle-work-order/list?status_id=1',
                    name: this.$t("menu.vehicleWorkOrderOpen"),
                    description: this.$t("pages.module.VEHICLE_WORK_ORDER.status.1.description"),
                    svgIcon: '/media/icons/duotune/general/gen013.svg',
                    class: "info",
                },
                {
                    slug: '/module/vehicle-work-order/list?status_id=2',
                    name: this.$t("menu.vehicleWorkOrderOngoing"),
                    description: this.$t("pages.module.VEHICLE_WORK_ORDER.status.2.description"),
                    svgIcon: '/media/icons/duotune/coding/cod009.svg',
                    class: "warning",
                },
                {
                    slug: '/module/vehicle-work-order/list?status_id=3',
                    name: this.$t("menu.vehicleWorkOrderCompleted"),
                    description: this.$t("pages.module.VEHICLE_WORK_ORDER.status.3.description"),
                    svgIcon: '/media/icons/duotune/general/gen043.svg',
                    class: "success",
                },
                {
                    slug: '/module/vehicle-work-order/list?status_id=4',
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.status.4.title"),
                    description: this.$t("pages.module.VEHICLE_WORK_ORDER.status.4.description"),
                    svgIcon: '/media/icons/duotune/ecommerce/ecm006.svg',
                    class: "warning",
                },
                {
                    slug: '/module/vehicle-work-order/list?status_id=5',
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.status.5.title"),
                    description: this.$t("pages.module.VEHICLE_WORK_ORDER.status.5.description"),
                    svgIcon: '/media/icons/duotune/general/gen040.svg',
                    class: "danger",
                },
                {
                    slug: '/module/vehicle-work-order/list?status_id=6',
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.status.6.title"),
                    description: this.$t("pages.module.VEHICLE_WORK_ORDER.status.6.description"),
                    svgIcon: '/media/icons/duotune/ecommerce/ecm009.svg',
                    class: "danger",
                },
            ]
        }
    },
    computed: {},
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.VEHICLE_WORK_ORDER"), []);
    }
}
</script>